export default function SecurityDescriptionText({
  description,
}: {
  description: string;
}) {
  return <p className="text-xs font-medium text-gray-400">{description}</p>;
}
